import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { User } from '@/shared/api';
import { Schema } from '@/shared/lib';

import {
  UserPresenceInfoSchema,
  type UserPresenceInfoSchemaType,
  type UserPresenceInfoInputSchemaType,
} from '../schemas';

const initStore = () => {
  const inputMap = ref<Map<User['id'], UserPresenceInfoInputSchemaType>>(new Map());

  const outputMap = computed<Map<User['id'], UserPresenceInfoSchemaType>>(
    () =>
      new Map(
        [...inputMap.value.entries()].map(([key, val]) => [
          key,
          Schema.methods.parse(UserPresenceInfoSchema, val),
        ]),
      ),
  );

  const getPresenseData = (userId: User['id']): UserPresenceInfoSchemaType | null =>
    outputMap.value.get(userId) ?? null;

  const setByUsers = (...users: ({ id: User['id'] } & UserPresenceInfoInputSchemaType)[]): void => {
    users.forEach((user) => {
      inputMap.value.set(user.id, { isOnline: user.isOnline, lastSeenAt: user.lastSeenAt });
    });
  };

  return { allData: outputMap, getPresenseData, setByUsers };
};

const useUsersPresenceStore = defineStore('users-presence', initStore);

export { useUsersPresenceStore };
